const system = {
  state: {
    showLoader: false,
    loaderMessage: '',
    showAlert: false,
    alertMessage: '',
    alertColor: '',
    companyLogo: '',
    fullScreenDialogForJob: false,
    jobId: null,
    isEdit: false,
    fullScreenDialogForInvoice: false,
    invoiceId: null,
    fullScreenDialogForPayment: false,
    paymentRecordId: null,
    globalEmailDialog: false,
    emailTemplateId: null,
    systemTopBarColor: 'primary',
    globalFullScreenEmail: false,
    communicationId: null,
    globalFileManager: false,
    fileManagerRequestResource: '',
    globalFileManagerForCustomer: false,
    companyId: null,
    globalAddressLayout: false,
    addressDetail: '',
    companyDetail: '',
    contactDetail: '',
    fullScreenAdvanceSearch: false,
    advanceSearchValue: '',
    globalNearMeCustomers: false,
    leadid: state => null,
    addressid: state => null,
    fullScreenDialogForQB: false,
    crmCompanyId: 0
  },

  mutations: {
    SET_SHOW_LOADER: (state, loaderObj) => {
      console.log(loaderObj)
      state.showLoader = loaderObj.status
      state.loaderMessage = loaderObj.message
    },
    SET_SHOW_ALERT: (state, alertObj) => {
      console.log(alertObj)
      state.showAlert = alertObj.showAlert
      state.alertMessage = alertObj.message
      state.alertColor = alertObj.color
    },
    SET_COMPANY_LOGO: (state, url) => {
      state.companyLogo = url
    },
    SET_TOPBAR_COLOR: (state, color) => {
      state.systemTopBarColor = color
    },
    SET_FULL_SCREEN_DIALOG_FOR_JOB: (state, fullScreenDialogForJobLoaderObj) => {
      console.log(fullScreenDialogForJobLoaderObj)
      state.fullScreenDialogForJob = fullScreenDialogForJobLoaderObj.status
      state.jobId = fullScreenDialogForJobLoaderObj.jobId
      state.isEdit = fullScreenDialogForJobLoaderObj.isEdit
    },
    SET_FULL_SCREEN_DIALOG_FOR_INVOICE: (state, fullScreenDialogForInvoiceLoaderObj) => {
      console.log(fullScreenDialogForInvoiceLoaderObj)
      state.fullScreenDialogForInvoice = fullScreenDialogForInvoiceLoaderObj.status
      state.invoiceId = fullScreenDialogForInvoiceLoaderObj.invoiceId
    },
    SET_FULL_SCREEN_DIALOG_FOR_PAYMENT: (state, fullScreenDialogForPaymentLoaderObj) => {
      console.log(fullScreenDialogForPaymentLoaderObj)
      state.fullScreenDialogForPayment = fullScreenDialogForPaymentLoaderObj.status
      state.paymentRecordId = fullScreenDialogForPaymentLoaderObj.paymentRecordId
    },
    SET_GLOBAL_EMAIL_DIALOG: (state, globalEmailDialogObj) => {
      console.log(globalEmailDialogObj)
      state.globalEmailDialog = globalEmailDialogObj.status
      state.emailTemplateId = globalEmailDialogObj.emailTemplateId
    },
    SET_GLOBAL_FULL_SCREEN_EMAIL: (state, globalFullScreenEmailObj) => {
      console.log(globalFullScreenEmailObj)
      state.globalFullScreenEmail = globalFullScreenEmailObj.status
      state.communicationId = globalFullScreenEmailObj.communicationId
    },
    SET_GLOBAL_FILE_MANAGER: (state, fileManagerRequest) => {
      state.globalFileManager = fileManagerRequest.status
      state.fileManagerRequestResource = fileManagerRequest.requestResource
    },
    SET_GLOBAL_FILE_MANAGER_FOR_CUSTOMER: (state, globalFileManagerForCustomerObj) => {
      state.globalFileManagerForCustomer = globalFileManagerForCustomerObj.status
      state.companyId = globalFileManagerForCustomerObj.companyId
    },
    SET_GLOBAL_ADDRESS_LAYOUT: (state, globalAddressLayoutObj) => {
      state.globalAddressLayout = globalAddressLayoutObj.status
      state.addressDetail = globalAddressLayoutObj.addressDetail
      state.companyDetail = globalAddressLayoutObj.companyDetail
      state.contactDetail = globalAddressLayoutObj.contactDetail
    },
    SET_FULL_SCREEN_ADVANCE_SEARCH: (state, fullScreenAdvanceSerachObj) => {
      console.log(fullScreenAdvanceSerachObj)
      state.fullScreenAdvanceSearch = fullScreenAdvanceSerachObj.status
      state.advanceSearchValue = fullScreenAdvanceSerachObj.advanceSearchValue
    },
    SET_GLOBAL_NEAR_ME_CUSTOMERS: (state, globalNearMeCustomersObj) => {
      console.log(globalNearMeCustomersObj)
      state.globalNearMeCustomers = globalNearMeCustomersObj.status
      state.leadid = globalNearMeCustomersObj.leadid
      state.addressid = globalNearMeCustomersObj.addressid
    },
    SET_FULL_SCREEN_DIALOG_FOR_QB: (state, qbRequestObj) => {
      state.fullScreenDialogForQB = qbRequestObj.status
      state.crmCompanyId = qbRequestObj.crmCompanyId
    }
  },
  actions: {
    SetLoader ({commit}, loaderObj) {
      commit('SET_SHOW_LOADER', loaderObj)
    },
    SetAlert ({commit}, alertObj) {
      commit('SET_SHOW_ALERT', alertObj)
    },
    SetCompanyLogo ({commit}, url) {
      commit('SET_COMPANY_LOGO', url)
    },
    SetTopBarColor ({commit}, color) {
      commit('SET_TOPBAR_COLOR', color)
    },
    SetFullScreenDialogForJob ({commit}, fullScreenDialogForJobLoaderObj) {
      commit('SET_FULL_SCREEN_DIALOG_FOR_JOB', fullScreenDialogForJobLoaderObj)
    },
    SetFullScreenDialogForInvoice ({commit}, fullScreenDialogForInvoiceLoaderObj) {
      commit('SET_FULL_SCREEN_DIALOG_FOR_INVOICE', fullScreenDialogForInvoiceLoaderObj)
    },
    SetFullScreenDialogForPayment ({commit}, fullScreenDialogForPaymentLoaderObj) {
      commit('SET_FULL_SCREEN_DIALOG_FOR_PAYMENT', fullScreenDialogForPaymentLoaderObj)
    },
    SetGlobalEmailDialog ({commit}, globalEmailDialogObj) {
      commit('SET_GLOBAL_EMAIL_DIALOG', globalEmailDialogObj)
    },
    SetGlobalFullScreenEmail ({commit}, globalFullScreenEmailObj) {
      commit('SET_GLOBAL_FULL_SCREEN_EMAIL', globalFullScreenEmailObj)
    },
    SetGlobalFileManager ({commit}, fileManagerRequest) {
      commit('SET_GLOBAL_FILE_MANAGER', fileManagerRequest)
    },
    SetGlobalFileManagerForCustomer ({commit}, globalFileManagerForCustomerObj) {
      commit('SET_GLOBAL_FILE_MANAGER_FOR_CUSTOMER', globalFileManagerForCustomerObj)
    },
    SetglobalAddressLayout ({commit}, globalAddressLayoutObj) {
      commit('SET_GLOBAL_ADDRESS_LAYOUT', globalAddressLayoutObj)
    },
    SetFullScreenAdvanceSerach ({commit}, fullScreenAdvanceSerachObj) {
      commit('SET_FULL_SCREEN_ADVANCE_SEARCH', fullScreenAdvanceSerachObj)
    },
    SetGlobalNearMeCustomers ({commit}, globalNearMeCustomersObj) {
      commit('SET_GLOBAL_NEAR_ME_CUSTOMERS', globalNearMeCustomersObj)
    },
    SetFullScreenDialogForQB ({commit}, qbRequestObj) {
      commit('SET_FULL_SCREEN_DIALOG_FOR_QB', qbRequestObj)
    }
  }
}

export default system



// WEBPACK FOOTER //
// ./src/store/modules/system.js